import * as React from 'react';
import { cn } from '@/lib/utils';

const ClassroomPlayer = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-classroom-player',
      // Estilo Base
      'rounded-xl border border-solid border-[var(--color-neutral-lightest)] bg-white p-2',
      'shadow-dropshadow-sm',

      className
    )}
    {...props}
  />
));
ClassroomPlayer.displayName = 'ClassroomPlayer';

const ClassroomPlayerFrame = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-classroom-player-frame',
      'relative w-full',
      // Estilos base
      'overflow-hidden rounded-xl bg-black shadow-dropshadow',
      'pt-[56.25%]', // 9/16 * 100 = 56.25%
      '[&_iframe]:absolute [&_iframe]:inset-0 [&_iframe]:h-full [&_iframe]:w-full [&_iframe]:overflow-hidden [&_iframe]:rounded-xl [&_iframe]:shadow-dropshadow-sm',
      className
    )}
    {...props}
  />
));
ClassroomPlayerFrame.displayName = 'ClassroomPlayerFrame';

export { ClassroomPlayer, ClassroomPlayerFrame };
